/**
 * @Author: HuangXin
 * @Date: 2023-10-07 09:38:25
 * @LastEditors: HuangXin
 * @LastEditTime: 2023-10-19 10:15:12
 * @FilePath: \ganranke-manbingsuifang-adminf:\Vue\my\miaowu\src\plugins\vant.js
 * @Description: 文件名跟UI库名称一致
 * @
 * @Copyright (c) 2023 by XXZX-HX\Lit 978843023@qq.com, All Rights Reserved.
 */

import Vue from 'vue'
import Vant, { Lazyload, Notify, Toast } from 'vant'
// import 'vant/lib/index.css';
// 为了能够覆盖默认的 less 变量，这里要把css 的后缀名改为 less
import 'vant/lib/index.less'
import '@/style/vant/customStyle.less'
import '@vant/touch-emulator'

Vue.use(Vant)

Vue.use(Lazyload)

// 注册时可以配置额外的选项
Vue.use(Lazyload, {
  lazyComponent: true
})

Notify.setDefaultOptions({ className: 'hx-notify' })
Toast.setDefaultOptions({ duration: 1500 })

Vue.prototype.$myToast = Vue.prototype?.$toast || function () {}
// Vue.prototype.$myNotify = Vue.prototype?.$notify || function () {};
// Dialog基本不用预处理，不改了
Vue.prototype.$myDialog = Vue.prototype?.$dialog || function () {}
Vue.prototype.$myMessageBox = Vue.prototype.$myDialog
// Vue.prototype.$myMessage = Vue.prototype?.$message || function () {};

Vue.prototype.$myNotify = (options) => {
  let { type } = options
  // Element : success/warning/info/error
  // Vant : primary success warning danger
  const typeMap = {
    info: 'primary',
    error: 'danger',
    fail: 'danger',
    warn: 'warning'
  }

  type = typeMap[type] || type
  return Vue.prototype?.$notify?.({ ...options, type })
}

// Vant 没有 Message ，用 myNotify 替代
Vue.prototype.$myMessage = Vue.prototype?.$myNotify || function () {}

// Dialog基本不用预处理，不改了
// Vue.prototype.$myDialog = (options) => {
//   let { type } = options;
//   // Element : success/warning/info/error
//   // Vant : primary success warning danger
//   const typeMap = {
//     info: "primary",
//     error: "danger",
//   };

//   type = typeMap[type] || type;

//   return Vue.prototype?.$dialog?.(options);
// };
